import React, { createContext, useContext, useState, useEffect } from 'react';
import { API_BASE } from '../Constants';

interface FeatureFlags {
  deep_research: boolean;
  data_ocean_tools: boolean;
  erp: boolean;
  comparison_mode: boolean;
  scheduled_tasks: boolean;
  // Integrações via MCP (piloto Slack): só true em chamadas autenticadas de
  // usuários da allowlist — ver IntegrationsContext.
  mcp_integrations: boolean;
}

const DEFAULT_FLAGS: FeatureFlags = {
  deep_research: false,
  data_ocean_tools: false,
  erp: false,
  comparison_mode: false,
  scheduled_tasks: false,
  mcp_integrations: false,
};

const FeatureFlagsContext = createContext<FeatureFlags>(DEFAULT_FLAGS);

export const useFeatureFlags = (): FeatureFlags => useContext(FeatureFlagsContext);

export const FeatureFlagsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [flags, setFlags] = useState<FeatureFlags>(DEFAULT_FLAGS);

  useEffect(() => {
    fetch(`${API_BASE}/api/info/features`)
      .then(res => res.json())
      .then(data => setFlags(data))
      .catch((err) => {
        console.error('Failed to fetch feature flags, features disabled by default:', err);
      });
  }, []);

  return (
    <FeatureFlagsContext.Provider value={flags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};
